// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".e6bd7aca48cc7313540176f0919ab305aa91cb69.chunk.bundle.js";
};